import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//Api
import pgrs_api from '../../../api/pgrs_api';

//Helpers
import { showMessage } from '../../../helpers/message';


//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../context/auth';
import NovoFormularioPGRS from './NovoFormularioPGRS';
import FichaFormularioPGRS from './FichaFormularioPGRS';

export default function FormularioPGRS({ permissao }) {
    const { setLoading } = useAuth();

    //Estado de controle para exibição da tela de novo gerador
    const [novo, setNovo] = useState(false);

    const [listaFormularioPGRS, setListaFormularioPGRS] = useState([]);

    //Estado de controle para exibição da tela de ficha do gerador
    const [ficha, setFicha] = useState(false);

    //Cabeçalhos da tabela de listagem de geradores
    const headersTabela = [
        { value: "Identificação", objectValue: "identificacao", align: "left", }
    ];
    
    function loadFormulariosPGRS() {
        setLoading(true);
        pgrs_api.GetList().then(response => {
            setListaFormularioPGRS(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        loadFormulariosPGRS()
    }, []);

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    function btnVoltar() {                
        setFicha(false);
        setNovo(false);
        loadFormulariosPGRS(); 
    }

    //Controle da exibição da tela de novo cadastro
    if (novo)
        return <NovoFormularioPGRS
            btnVoltar={btnVoltar}
        />

    //Controle da exibição da tela de ficha
    if (ficha) {
        return <FichaFormularioPGRS
            btnVoltar={btnVoltar}
            id={ficha}
        />
    }


    return (
        <>
            <MainCard
                noCard
                btnCadastro={permissao === "Editar" ? "Adicionar" : null}
                onClickBtnCadastro={() => setNovo(true)}
            >
                <div className={`w-100 `}>
                    <div className='mt-4'>
                        <TabelaListagem
                            headers={headersTabela}
                            items={listaFormularioPGRS}
                            actions={actions}
                            title="Lista de formulários PGRS"
                            options={{ print: false, search: true, pagination: true }}
                        />
                    </div>
                </div>
            </MainCard >
        </>
    )
}
